"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactLazyload = _interopRequireDefault(require("react-lazyload"));
var _lodash = require("lodash");
var _placeholderImg = _interopRequireDefault(require("../elements-image/placeholderImg"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SpecialEvents = function SpecialEvents(_ref) {
  var _ref$sectionTitle = _ref.sectionTitle,
    sectionTitle = _ref$sectionTitle === void 0 ? '' : _ref$sectionTitle,
    _ref$sectionSubtitle = _ref.sectionSubtitle1,
    sectionSubtitle1 = _ref$sectionSubtitle === void 0 ? '' : _ref$sectionSubtitle,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items;
  var _get = (0, _lodash.get)(items, '0', {}),
    _get$contentLinkUrl = _get.contentLinkUrl,
    contentLinkUrl = _get$contentLinkUrl === void 0 ? '' : _get$contentLinkUrl,
    _get$contentLinkText = _get.contentLinkText,
    contentLinkText = _get$contentLinkText === void 0 ? '' : _get$contentLinkText,
    _get$contentTitle = _get.contentTitle,
    contentTitle = _get$contentTitle === void 0 ? '' : _get$contentTitle,
    _get$contentSubtitle = _get.contentSubtitle1,
    contentSubtitle1 = _get$contentSubtitle === void 0 ? '' : _get$contentSubtitle,
    _get$contentCloudinar = _get.contentCloudinaryId,
    contentCloudinaryId = _get$contentCloudinar === void 0 ? '' : _get$contentCloudinar;
  var backgroundStyle = {
    backgroundImage: "url(https://img.peerspace.com/image/upload/c_crop,g_custom/g_auto,q_auto,f_auto,fl_progressive/".concat(contentCloudinaryId, ")")
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "SpecialEvents flex middle"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "front details flex column"
  }, /*#__PURE__*/_react.default.createElement("h4", null, sectionTitle), /*#__PURE__*/_react.default.createElement("div", null, sectionSubtitle1), /*#__PURE__*/_react.default.createElement("div", {
    className: "value-proposition"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "/web-templates/assets/images/save_time.svg?v=rb"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "heavy"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "homepage.special_events.save_time",
    defaultMessage: "Save time booking"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "value-proposition"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "/web-templates/assets/images/stress_free.svg?v=rb"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "heavy"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "homepage.special_events.stress_free",
    defaultMessage: "Stress-free planning"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "value-proposition"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "/web-templates/assets/images/unlock.svg?v=rb"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "heavy"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "homepage.special_events.unlock_spaces",
    defaultMessage: "Unlock new spaces"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "front flex column"
  }, /*#__PURE__*/_react.default.createElement(_reactLazyload.default, {
    offset: 100,
    placeholder: _placeholderImg.default,
    once: true
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: contentLinkUrl
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "image-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "image text-white",
    style: backgroundStyle
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-uppercase"
  }, contentTitle), /*#__PURE__*/_react.default.createElement("h3", null, contentSubtitle1), /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-default"
  }, contentLinkText))))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "skewed-background"
  }));
};
SpecialEvents.propTypes = {
  sectionTitle: _propTypes.default.string,
  sectionSubtitle1: _propTypes.default.string,
  items: _propTypes.default.array
};
var _default = exports.default = SpecialEvents;